var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.966 7.56a1.05 1.05 0 0 0-.33-.483.97.97 0 0 0-.528-.217l-5.683-.867L10.88.589a1.03 1.03 0 0 0-.369-.43.97.97 0 0 0-1.06 0 1.03 1.03 0 0 0-.369.43L6.535 5.982.852 6.86a1 1 0 0 0-.501.235c-.143.125-.25.29-.307.476a1.1 1.1 0 0 0-.014.56c.044.183.135.351.263.485l4.125 4.181-.999 5.938c-.04.197-.025.402.043.59s.187.352.342.471a.96.96 0 0 0 1.083.068l5.093-2.791 5.093 2.79c.14.083.299.127.46.126a.97.97 0 0 0 .589-.198c.155-.117.275-.277.345-.462.071-.185.09-.388.054-.584l-.998-5.937 4.124-4.181a1.05 1.05 0 0 0 .307-.485c.057-.188.061-.39.012-.581Z",
  clipRule: "evenodd"
})));
export default SvgStar;